import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RonaStateComponent } from '@nimbus-library/features/agent-assistant/rona-state/rona-state.component';
import { LocalizationModule } from '@nimbus-library/features/localization/localization.module';
import { SharedUIModule } from '@nimbus-library/features/shared/shared.ui.module';
import { UserSettingsModule } from '@nimbus-library/features/user-settings/user-settings.module';
import { AvailabilityStateComponent } from '@nimbus-library/features/agent-assistant/availability-state/availability-state.component';
import { IUserTasksCapacityService } from '@nimbus-global/features/user-tasks-capacity/services/i-user-tasks-capacity.service';
import { UserTasksCapacityService } from '@nimbus-global/features/user-tasks-capacity/services/user-tasks-capacity.service';
import { UserTpCapacityButtonComponent } from '@nimbus-global/features/user-tasks-capacity/components/user-tp-capacity-button/user-tp-capacity-button.component';
import { AfterCallWorkStateComponent } from './after-call-work-state/after-call-work-state.component';
import { AgentAssistantComponent } from './agent-assistant/agent-assistant.component';

@NgModule({
  declarations: [AfterCallWorkStateComponent, AgentAssistantComponent, RonaStateComponent, AvailabilityStateComponent],
  exports: [AgentAssistantComponent],
  imports: [CommonModule, UserSettingsModule, LocalizationModule, SharedUIModule, UserTpCapacityButtonComponent],
  providers: [{ provide: IUserTasksCapacityService, useExisting: UserTasksCapacityService }],
})
export class AgentAssistantModule {}
